<template>
  <div v-if="visible" class="app-image-modal">
    <div class="app-image-modal__body">
      <img :src="imageUrl" alt="">
    </div>
    <button type="button" class="app-image-modal__close btn-plus" data-bs-dismiss="modal" aria-label="Close" @click.prevent="close"></button>
  </div>
</template>

<script>
  export default {
    name: "AppVideoModal",
    data() {
      return {
        storePopupName: 'Image'
      }
    },
    computed: {
      visible() {
        return this.$store.getters['Popups/hasVisiblePopup'](this.storePopupName)
      },
      imageUrl() {
        return this.$store.getters['Popups/getImageModalUrl']
      }
    },
    methods: {
      close() {
        this.$store.commit('Popups/closeAllPopups')
      },
    }
  }
</script>
